import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgOftenOilyGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M22.42 16.97c-.2-.25-.41-.51-.6-.76-2.06-2.71-2.24-7.44-2.24-7.48-.01-.41-.36-.72-.76-.73-.41.01-.74.34-.74.75 0 .04-.03 4.48-2.37 7.46-1.27 1.62-2.71 3.46-2.71 5.83 0 3.24 2.51 5.69 5.83 5.69 3.49 0 5.83-2.37 5.83-5.89.01-2.09-1.18-3.57-2.24-4.87Zm-3.59 9.26c-2.51 0-4.33-1.76-4.33-4.19 0-1.86 1.22-3.41 2.45-4.99.9-1.15 1.49-2.47 1.88-3.72.38 1.31.95 2.67 1.8 3.79.2.27.42.53.63.8.98 1.22 1.91 2.36 1.91 3.93 0 2.7-1.66 4.38-4.34 4.38ZM32.56 29.27c-.2-.25-.41-.5-.6-.76-2.05-2.7-2.23-7.41-2.23-7.46a.758.758 0 0 0-.75-.73h-.01c-.41.01-.74.34-.74.75 0 .04-.03 4.45-2.36 7.43-1.27 1.62-2.7 3.45-2.7 5.82 0 3.23 2.5 5.67 5.81 5.67 3.48 0 5.82-2.36 5.82-5.87 0-2.08-1.19-3.55-2.24-4.85Zm-3.58 9.23c-2.5 0-4.31-1.75-4.31-4.17 0-1.85 1.21-3.4 2.44-4.97.9-1.14 1.49-2.46 1.87-3.71.38 1.3.94 2.66 1.79 3.77.2.27.41.53.63.79.98 1.21 1.9 2.36 1.9 3.91 0 2.7-1.66 4.38-4.32 4.38Z",
    fill: "currentColor"
  }));
}

export { SvgOftenOilyGlyphSecondary as default };
